// extracted by mini-css-extract-plugin
export default {"text":"EditVersions_text__1ggnv","buttonWrapper":"EditVersions_buttonWrapper__iw919"};